import "../../../../chunk-D57E6H3M.mjs";

// src/components/composite/Timeline/ContentChips/productMentions.ts
import { PRODUCT_MENTION_LABEL } from "../../../../domain/index.mjs";
var PRODUCT_MENTION_REGEX = new RegExp(String.raw`@\[(${PRODUCT_MENTION_LABEL})\](?:\([^)]*\))?`, "g");
function resolveProductMention(productMap, productKey) {
  if (!productMap || typeof productKey !== "string") return void 0;
  if (Object.hasOwn(productMap, productKey)) return productMap[productKey];
  const trimmed = productKey.trim();
  return Object.hasOwn(productMap, trimmed) ? productMap[trimmed] : void 0;
}
function unresolvedMentionText(productKey) {
  return productKey.trim();
}
function resolveProductUrl(url, storeDomain) {
  if (!url) return void 0;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (!storeDomain) return url;
  const base = storeDomain.endsWith("/") ? storeDomain.slice(0, -1) : storeDomain;
  return `${base}${url.startsWith("/") ? url : `/${url}`}`;
}
export {
  PRODUCT_MENTION_REGEX,
  resolveProductMention,
  resolveProductUrl,
  unresolvedMentionText
};
//# sourceMappingURL=productMentions.mjs.map